class EvidenceController {
    constructor($filter,$sce) {
        "ngInject";
        $(document).scrollTop(0);
        this.$filter=$filter;
        this.$sce=$sce;
    }
}
//  测试
export default EvidenceController;



// WEBPACK FOOTER //
// ./src/app/components/page/evidence/evidence.controller.js